import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  MainBlock,
  Table,
  Thead,
  TrHead,
  Th,
  Tbody,
  TrBody,
  Td,
  ScrolledBlock,
  ThDummy,
  TdDummy,
  TdUserNum,
  ThUserNum,
} from './styles/DeviceListsStyles';

const createHeader = () => (
  <TrHead>
    <Th>
      <FormattedMessage id="device.DeviceLists.title.deviceNickname" />
    </Th>
    <Th>
      <FormattedMessage id="device.DeviceLists.title.deviceName" />
    </Th>
    <Th>
      <FormattedMessage id="device.DeviceLists.title.deviceSerial" />
    </Th>
    <ThUserNum>
      <FormattedMessage id="device.DeviceLists.title.deviceUseNum" />
    </ThUserNum>
    <ThDummy />
  </TrHead>
);

const createList = (idx, list, onSelect) => {
  const onClickDevice = `onClickDevice${idx}`;
  return (
    <TrBody
      className="clickableItem"
      id={onClickDevice}
      key={onClickDevice}
      onClick={() => onSelect(list.deviceId)}
    >
      <Td>{list.deviceNickname}</Td>
      <Td>{list.deviceName}</Td>
      <Td>{list.deviceSerial}</Td>
      <TdUserNum>{list.userCount}</TdUserNum>
      <TdDummy />
    </TrBody>
  );
};

const DeviceLists = ({ devices, onSelect }) => (
  <MainBlock className="deviceLists">
    <div>
      <Table>
        <Thead>{createHeader()}</Thead>
      </Table>
    </div>
    <ScrolledBlock id="canDeviceScrollTable">
      <Table>
        <Tbody>
          {devices &&
            devices.map((list, idx) => createList(idx, list, onSelect))}
        </Tbody>
      </Table>
    </ScrolledBlock>
  </MainBlock>
);

DeviceLists.propTypes = {
  devices: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default DeviceLists;
